import { render } from "./BackerCenterPaymentsTabs.vue?vue&type=template&id=bb243836"
import script from "./BackerCenterPaymentsTabs.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__